
<template>
  <div class="complete_content">
    <dd-header
      :headerSubContentType=1
      :headerTelContentType=1
    />
    <div id="container">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="pageList"
      />
      <div id="content">
        <div class="title">
          <h2>注文完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>ご注文ありがとうございました。</li>
            <li>注文完了メールを自動送信しました。</li>
            <li>
              <a @click="goTop">TOPへ戻る</a>
            </li>
          </ul>
        </div>
        <div id="login">
          <div id="login_icon">
            <div>
              <img :src="getImage('common/logo.png')">
            </div>
            <div class="sub_title">
              <label>My size, My lifestyle.</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/SiteMap'
import LoginForm from '../components/login/LoginForm'

export default {
  name: 'orderComplete',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-login': LoginForm
  },
  data () {
    return {
      pageKey: 'orderComp',
      pageList: []
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({
        name: 'DcTop'
      })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    let orderForm = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    if (!orderForm || Object.keys(orderForm) <= 0) {
      this.pageList = App.getLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    } else {
      this.pageList = orderForm.pageList
      App.setLocalStorage(DC_STORAGE_KEY.PAGE_LIST, this.pageList)
    }
    App.removeLocalStorage(DC_STORAGE_KEY.FILE_NAME)
    App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)

    App.removeLocalStorage(DC_STORAGE_KEY.PREF_RESEARCH)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_CHECKED)
    App.removeLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/OrderComplete.vue